import { PartnerService } from '../services/partner.service'
import { partnerConstants } from '../constants/partner.constants'

const getBalancePoints = () => async dispatch => {
	dispatch({
		type: partnerConstants.LOADING_POINTS
	})

	return PartnerService.getBalancePoints()
		.then(points => {
			dispatch(updateBalancePoints(points))
			dispatch({
				type: partnerConstants.POINTS_WAS_LOADED
			})
		})
		.catch(error => {
			dispatch(updateBalancePoints(null))
			dispatch({
				type: partnerConstants.POINTS_WAS_LOADED
			})
		})
}

const updateBalancePoints = points => dispatch => {
	dispatch({
		type: partnerConstants.GET_BALANCE_POINTS,
		payload: points
	})
}

export const partnerActions = {
	getBalancePoints,
	updateBalancePoints
}
